import { createInstance } from '@datapunt/matomo-tracker-react';

export const instance = createInstance({
  urlBase: 'https://hit.embrapa.io',
  siteId: process.env.REACT_APP_MATOMO_ID,
  linkTracking: false,
});
